import React from 'react';
import { Stack } from '@tanium/react-stack';
import { Placement } from '@tanium/react-tooltip';
import { InfoTooltip } from '@tanium/react-info-tooltip';
import styled from '@tanium/react-emotion-9';
import { css } from '@tanium/style-system';

export interface TextProps {
  text: React.ReactNode;
  helpText?: React.ReactNode;
  placement?: Placement;
}

const SmallBoldText = styled('span')(
  css({
    fontSize: 13,
    fontWeight: 'bold',
    color: 'gray',
  })
);

export const TextWithInfoTooltip: React.VFC<{
  text: React.ReactNode;
  helpText?: React.ReactNode;
  placement?: Placement;
}> = ({ text, helpText, placement }: TextProps) => {
  return (
    <Stack itemSpacing={1}>
      <SmallBoldText>{text}</SmallBoldText>
      <InfoTooltip content={helpText} placement={placement} backgroundColor="gray" />
    </Stack>
  );
};
